import React from "react";
import styles from "./Pricing.module.scss";
import Avatar from "../../../../components/Avatar/Avatar";
import Surcharge from "./components/Surcharge";
import OtherFees from "./components/OtherFees";
import Tiered from "./components/Tiered";
import DualPricing from "./components/DualPricing";
import FlatRate from "./components/FlatRate";
import ICPlus from "./components/ICPlus";
import useCommonStore from "../../../../stores/common";
import useMerchantStore from "../../../../stores/merchant";

function Pricing() {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);

  const renderPricing = () => {
    if (!activeApp?.qualifiedtype) return null;
    if (activeApp.qualifiedtype === "tiered") return <Tiered activeApp={activeApp} minimized={!expandDetails} />;
    if (activeApp.qualifiedtype === "surcharge") return <Surcharge activeApp={activeApp} />;
    if (activeApp.qualifiedtype === "dual_pricing") return <DualPricing activeApp={activeApp} />;
    if (activeApp.qualifiedtype === "flat_rate") return <FlatRate activeApp={activeApp} minimized={!expandDetails} />;
    if (activeApp.qualifiedtype === "ic_plus") return <ICPlus activeApp={activeApp} minimized={!expandDetails} />;
    return null;
  };

  const cardRatesContent = renderPricing();
  const showCardRatesPlaceholder = !cardRatesContent;

  return (
    <div className={`${styles.pricing} ${expandDetails ? styles.expanded : ""}`}>
      <div className={styles.rep}>
        <Avatar size="medium" name={activeApp?.user?.name?.charAt(0)} />
        <div className={styles.rep_details}>
          <p className={styles.rep_label}>Representative</p>
          <p className={styles.rep_name}>
            {activeApp?.user?.name}
            <span className={styles.rep_id}> | {activeApp?.user?.ems_rep_id || "-"}</span>
          </p>
        </div>
      </div>

      <div className={styles.body}>
        <div className={expandDetails ? styles.card : ""}>
          <div className={styles.section_head}>
            <h4 className={styles.section_title}>Pricing structure</h4>
          </div>
          <OtherFees activeApp={activeApp} />
        </div>

        <div className={expandDetails ? styles.card : ""}>
          <div className={styles.section_head}>
            <h4 className={styles.section_title}>Card rates</h4>
          </div>
          {cardRatesContent}
          {showCardRatesPlaceholder && (
            <div className={styles.card_rates_placeholder}>
              <p className={styles.card_rates_placeholder_text}>No card rates configured</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Pricing;
